import { TelephonyBanner, useTelephonyIssue } from '@/components/dialer/TelephonyBlocker';
import { pickBanner } from './bannerPriority';
import { ImpersonationBanner, useImpersonation } from './ImpersonationBanner';

/**
 * The dialer's single banner place (DES-14). Impersonation (W7, SU-1) comes
 * first, then telephony; paused session (W3) and CRM status (W4) join the
 * priority list in ./bannerSlot when they are built.
 */
export function DialerBannerSlot() {
  const impersonation = !!useImpersonation();
  const telephony = !!useTelephonyIssue();
  const shown = pickBanner({ impersonation, telephony });
  if (shown === 'impersonation') return <ImpersonationBanner />;
  if (shown === 'telephony') return <TelephonyBanner />;
  return null;
}

export default DialerBannerSlot;
